import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { signIn } from "../firebase/auth/functions.tsx";
import { MailOutline, PasswordOutlined, VisibilityOutlined, VisibilityOffOutlined } from "@mui/icons-material";
import Icon from "../widgets/icon.jsx";
import logo from "../assets/img/LogoFullBM.webp";
import { useTranslation } from "react-i18next";

export default function LoginPage() {
    const navigate = useNavigate();
    const { t } = useTranslation();

    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);

    const [searchParams, setSearchParams] = useSearchParams();
    
    console.log(searchParams.get('redirect'));

    async function submit() {
        setLoading(true);

        const result = await signIn(document.getElementById('email').value, document.getElementById('password').value);
        console.log(result);
        if (result.getSuccess()) {
            navigate(searchParams.get('redirect') ?? '/');
        }

        setLoading(false);
    }

    const handleTogglePassword = () => {
        setShowPassword(!showPassword);
        var x = document.getElementById("password");
        if (x.type === "password") {
            x.type = "text";
        } else {
            x.type = "password";
        }
    };

    return <div>
        <div className="login-login-container">
            <div className="login-login-card">
                <div className="login-login-form">
                    <div className="login-login-header">
                        <img src={logo} alt="Company Logo"/>
                        <h1>{t('login.title')}</h1>
                        <p>{t('login.subtitle')}</p>
                    </div>
                    
                    <div>
                        <div className="login-form-group">
                            <label htmlFor="email">{t('login.email')}</label>
                            <div className="login-input-field">
                                <Icon icon={<MailOutline className="login-input-field-icon" color="primary"/>}/>
                                <input type="email" id="email" name="email" placeholder={t('login.enterMail')} required autoComplete="email"/>
                            </div>
                        </div>
                        
                        <div className="login-form-group">
                            <label htmlFor="password">{t('login.password')}</label>
                            <div className="login-input-field">
                                <Icon icon={<PasswordOutlined className="login-input-field-icon" color="primary"/>}/>
                                <input type={showPassword?"text":"password"} id="password" name="password" placeholder={t('login.enterPassword')} required autoComplete="current-password"/>
                                <button
                                    type="button"
                                    className="login-password-toggle"
                                    onClick={handleTogglePassword}
                                    aria-label={showPassword ? 'Hide password' : 'Show password'}
                                >
                                    {showPassword ? <Icon icon={<VisibilityOffOutlined className="login-button-icon" color="primary"/>}/> : <Icon icon={<VisibilityOutlined className="login-button-icon" color="primary"/>}/>}
                                </button>
                            </div>
                            <div className="login-forgot-password">
                                <a href="#">{t('login.forgotPassword')}</a>
                            </div>
                        </div>
                        
                        <button className="login-login-button" onClick={() => {submit();}}>{t('login.signIn')}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>;
}